import { createTheme } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createTheme';

import { rem } from '../utils/styles';

export type ColorClass = 'default' | 'success' | 'error' | 'warning';
export const Rubik = '"Rubik", "Roboto", "Helvetica", "Arial", sans-serif';
export const Roboto = '"Roboto", "Helvetica", "Arial", sans-serif';
export const Manrope = '"Manrope","Roboto", "Arial", sans-serif';
export enum COLOR {
	title = '#828282',
	text = '#4F4F4F',
	blue = '#7396FD',
	lightBlue = '#FAFBFD',
	gray = '#5F5C7F',
	details = '#9EABBE',
	success = '#27AE60',
	warning = '#FF9800',
	link = '#0091FF',
	block = '#ECF1F8',
	error = '#B00020',
	linkBlue = '#2F80ED',
	orange = '#FF9800',
	green = '#27AE60',
	gray3 = '#828282'
}
export const ColorClasses = ['default', 'success', 'error', 'warning'];
/**
 * Override Custom variables with theme object.
 */
declare module '@material-ui/core/styles/createTheme' {
	interface Theme {
		rem: typeof rem;
	}
	// allow configuration using `createMuiTheme`
	interface ThemeOptions {
		rem?: typeof rem;
	}
}
const DmartTheme = (theme: Theme) =>
	createTheme({
		rem,
		palette: {
			primary: { main: '#046D39' },
			secondary: { main: '#165161' },
			error: {
				main: '#F44336'
			}
		},
		overrides: {
			MuiInputLabel: {
				root: {
					color: '#84818A'
				}
			},
			MuiOutlinedInput: {
				notchedOutline: {
					borderColor: 'rgba(0, 0, 0, 0.87)'
				},
				input: {
					'&::placeholder': {
						color: 'rgb(0, 0, 0) !important',
						opacity: 0.6
					},
					'&::-webkit-input-placeholder': {
						color: 'rgb(0, 0, 0) !important',
						opacity: 0.6
					}
				}
			},
			MuiInput: {
				input: {
					'&::placeholder': {
						color: 'rgb(0, 0, 0) !important',
						opacity: 0.6
					},
					'&::-webkit-input-placeholder': {
						color: 'rgb(0, 0, 0) !important',
						opacity: 0.6
					}
				}
			},
			MuiTableSortLabel: {
				root: {
					'&:hover': {
						color: 'rgba(0, 0, 0, 0.87)'
					},
					'&:hover $icon': {
						opacity: 1
					}
				}
			},
			MuiSnackbar: {
				root: {
					marginTop: 56
				}
			}
		},
		props: {
			MuiTextField: {
				fullWidth: true,
				variant: 'outlined',
				margin: 'normal',
				InputLabelProps: {
					shrink: true
				}
			},
			MuiCheckbox: {
				color: 'primary'
			},
			MuiRadio: {
				color: 'primary'
			}
		}
	});

export default DmartTheme;
